import Promise from 'bluebird';
import wooGlobal from './wooGlobal';

function deleteReview (url, reviewType) {
  const lang = wooGlobal.language;

  if (url.includes('/')) {
    url = encodeURIComponent(url);
  }

  return Promise.resolve($.ajax({
    type: 'DELETE',
    url: `/${lang}/${reviewType}/delete/${url}`
  }));
}

function createAdvancedReview (url) {
  const lang = wooGlobal.language;
  return Promise.resolve($.post(`/${lang}/project/create`, { url }))
    .then(response => {
      if (!response.result) {
        throw new Error(response.reason);
      }
      return response;
    });
}

module.exports = {
  createAdvancedReview,
  deleteReview
};
